export const FLAGS = {
  GEOJSON_BACKEND_HYDRATION: "geojson_backend_hydration",
  GEOJSON_PERF_LOG: "geojson_perf_log",
  TILE_LAYER_FALLBACK_TRANSITIONS: "feature.tile_layer_fallback_transitions",
  CURRENT_CHANGELOG_VERSION: "current_changelog_version",
  TELEMETRY_ENABLED: "telemetry.enabled",
  TELEMETRY_TRACES_ENABLED: "telemetry.traces.enabled",
  TELEMETRY_TRACES_SAMPLING_RATE_PERCENT: "telemetry.traces.sampling_rate_percent",
  TELEMETRY_METRICS_ENABLED: "telemetry.metrics.enabled",
  TELEMETRY_LOGS_ENABLED: "telemetry.logs.enabled",
  TELEMETRY_LOGS_SAMPLING_RATE_PERCENT: "telemetry.logs.sampling_rate_percent",
  TELEMETRY_WEB_VITALS_SAMPLING_RATE_PERCENT: "telemetry.web_vitals.sampling_rate_percent",
} as const;

export const FLAG_DEFAULTS = {
  [FLAGS.GEOJSON_BACKEND_HYDRATION]: false,
  [FLAGS.GEOJSON_PERF_LOG]: false,
  [FLAGS.TILE_LAYER_FALLBACK_TRANSITIONS]: true,
  [FLAGS.CURRENT_CHANGELOG_VERSION]: "",
  [FLAGS.TELEMETRY_ENABLED]: false,
  [FLAGS.TELEMETRY_TRACES_ENABLED]: false,
  [FLAGS.TELEMETRY_TRACES_SAMPLING_RATE_PERCENT]: 0,
  [FLAGS.TELEMETRY_METRICS_ENABLED]: false,
  [FLAGS.TELEMETRY_LOGS_ENABLED]: false,
  [FLAGS.TELEMETRY_LOGS_SAMPLING_RATE_PERCENT]: 5,
  [FLAGS.TELEMETRY_WEB_VITALS_SAMPLING_RATE_PERCENT]: 0,
} as const;

export function getDefaultTraceSamplingRatePercent(): number {
  return FLAG_DEFAULTS[FLAGS.TELEMETRY_TRACES_SAMPLING_RATE_PERCENT];
}
